import { auditService } from '#apps/client-web/features/audit/services/audit';
import { auditFormService } from '#apps/client-web/features/audit-form/services/audit-form';
import { fileStorageService } from '#apps/client-web/features/file-storage/services/file-storage';
import { uploadApiService } from '#apps/client-web/features/upload/services/upload-api';
import { ReactQueryClientService } from '#apps/client-web/app/services/react-query-client';
import { useLogger } from '#apps/client-web/app/hooks/use-logger';
import { NestedPageLayout } from '#apps/client-web/app/components/nested-page-layout';

import { CenteredLayout } from '#packages/web/foundations/layouts/centered-layout';

import { AuditReviewSubmitPageContainer } from './audit-review-submit-page.container';
import { useAuditReviewSubmitPageViewModel } from './audit-review-submit-page.view-model';

export const AuditReviewSubmitPage = () => {
  const logger = useLogger('pages/audit-review-submit');

  const viewModel = useAuditReviewSubmitPageViewModel({
    auditService,
    auditFormService,
    fileStorageService,
    uploadApiService,
    queryClient: ReactQueryClientService.offlineQueryClient,
    logger,
  });

  return (
    <NestedPageLayout title="Review and Submit">
      <CenteredLayout horizontal>
        <AuditReviewSubmitPageContainer viewModel={viewModel} logger={logger} />
      </CenteredLayout>
    </NestedPageLayout>
  );
};
